import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useResourceCount } from '../../../hooks/useResourceCount'

import Icon from '../../../components/ui/Icon'
import { Button } from '../../../components/buttons/Button'
import PageHeader from '../../../components/ui/pageHeader/PageHeader'
import { ClubList } from '../../../components/authenticated/management/club/clubList/ClubList'

export const ManagerClubs = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('clubs')
  const { count: clubsNumber } = useResourceCount('/api/v1/clubs/count')

  const goTo = (path: string) => {
    navigate(path)
  }

  return (
    <>
      <PageHeader
        title={{
          eyebrow:
            clubsNumber === null
              ? undefined
              : t('clubs.page-header.eyebrow', {
                  count: clubsNumber,
                }),
          h1: t('clubs.page-header.title'),
        }}
        sub={t('clubs.page-header.subtitle')}
        actions={[
          <Button
            key="new-club"
            label={t('clubs.page-header.new-btn')}
            icon={<Icon name="plus" size={14} />}
            size="md"
            onClick={() => goTo('/m/clubs/new')}
          />,
        ]}
      />
      <ClubList />
    </>
  )
}
